@import "../../../../globalStyles/commons";


.expression {
  display: flex;
  gap: .5rem;
  align-items: center;
  padding-bottom: 1rem;
}
